import { render, staticRenderFns } from "./YellowFlags.vue?vue&type=template&id=26872f52&"
import script from "./YellowFlags.vue?vue&type=script&lang=js&"
export * from "./YellowFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports